import { Component, inject, OnInit, signal } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AuthService } from '../../core/auth/auth.service';
import { ApiService } from '../../core/services/api.service';
import { GamificationService } from '../../core/services/gamification.service';
import { ThemeService } from '../../core/services/theme.service';
import { ProjectListViewService } from '../../core/services/project-list-view.service';
import { HasPermissionDirective } from '../../shared/directives/has-permission.directive';
import { UserGamification } from '../../models/gamification.model';
import { NotificationBellComponent } from './notification-bell/notification-bell.component';
import { ChatOpenService } from '../../features/chatbot/chat-open.service';
import { FeedbackFormDialogComponent } from '../../features/feedback/feedback-form-dialog/feedback-form-dialog.component';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    TitleCasePipe,
    RouterLink,
    RouterLinkActive,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    HasPermissionDirective,
    NotificationBellComponent,
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  host: { '[class.collapsed]': 'collapsed()' },
})
export class SidebarComponent implements OnInit {
  readonly auth = inject(AuthService);
  readonly theme = inject(ThemeService);
  readonly chatOpen = inject(ChatOpenService);
  private readonly api = inject(ApiService);
  private readonly gamificationSvc = inject(GamificationService);
  private readonly projectListView = inject(ProjectListViewService);
  private readonly dialog = inject(MatDialog);

  readonly collapsed = signal(false);
  readonly persona = signal<string | null>(null);
  readonly gamification = signal<UserGamification | null>(null);

  get initial(): string {
    const name = this.auth.currentUser()?.name ?? '';
    return name.charAt(0).toUpperCase();
  }

  ngOnInit(): void {
    this.api
      .get<{ persona: string | null; theme_preference?: string; project_list_view?: string }>(
        '/api/profile',
      )
      .subscribe({
        next: (p) => {
          this.persona.set(p.persona);
          this.theme.syncFromProfile(p.theme_preference);
          this.projectListView.syncFromProfile(p.project_list_view);
        },
      });
    this.gamificationSvc.getMyStats().subscribe({
      next: (g) => this.gamification.set(g),
      error: () => {},
    });
  }

  toggle(): void {
    this.collapsed.update((v) => !v);
  }

  openFeedback(): void {
    this.dialog.open(FeedbackFormDialogComponent, { width: '580px', autoFocus: false });
  }
}
